/* Zapz storefront — Shopify edition.
   Data: window.ZAPZ (snippets/zapz-data.liquid) + window.ZAPZ_LOOKS (sections/zapz-catalog.liquid).
   Every section root carries data-zapz="<type>" and is initialised independently, so sections work
   on any template and re-render live in the theme editor (shopify:section:load). */
(function () {
  'use strict';

  var Z = window.ZAPZ || { products: [], settings: {}, routes: {} };
  var R = Z.routes || {};
  var S = Z.settings || {};
  var SETTINGS = {
    bundleMin: +S.bundleMin || 2,
    bundleOff: (+S.bundlePct || 0) / 100,
    tiers: (function () {
      var t = String(S.bundleTiers || '').split(',').map(function (x) { var a = x.split(':'); return { min: +a[0], off: (+a[1] || 0) / 100 }; }).filter(function (x) { return x.min > 0 && x.off > 0; });
      if (!t.length && +S.bundlePct > 0) t = [{ min: +S.bundleMin || 2, off: +S.bundlePct / 100 }];
      return t.sort(function (a, b) { return a.min - b.min; });
    })(),
    packs: S.packs && S.packs.length ? S.packs : [1, 2, 3],
    freeShipping: +S.freeShipping || 0,
    shipNote: S.shipNote || '',
    daysPerJar: 30
  };

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  // Build the format from a sample rendered by Shopify in the shopper's currency (e.g. "$1,234.56 CAD", "1.234,56 €").
  var MONEY_FMT = (function () {
    var smp = window.ZAPZ && window.ZAPZ.moneySample;
    if (smp) {
      var m = /1([.,'   ]?)234(?:([.,])56)?/.exec(smp);
      if (m) {
        var ts = m[1], ds = m[2], key = !ds ? (ts === '.' ? 'amount_no_decimals_with_comma_separator' : 'amount_no_decimals') : ds === ',' ? 'amount_with_comma_separator' : ts === "'" ? 'amount_with_apostrophe_separator' : 'amount';
        return smp.replace(m[0], '{{' + key + '}}');
      }
    }
    return (window.ZAPZ && window.ZAPZ.moneyFormat) || '${{amount}}';
  })();
  function fmtCents(c) {
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(MONEY_FMT), key = m ? m[1] : 'amount';
    function d(num, dec, ts, ds) { var p = (num / 100).toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts); return p[1] ? p[0] + ds + p[1] : p[0]; }
    var v = key === 'amount_no_decimals' ? d(c, 0, ',', '.') : key === 'amount_with_comma_separator' ? d(c, 2, '.', ',') : key === 'amount_no_decimals_with_comma_separator' ? d(c, 0, '.', ',') : key === 'amount_with_apostrophe_separator' ? d(c, 2, "'", '.') : d(c, 2, ',', '.');
    return MONEY_FMT.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  }
  function money(n) { return fmtCents(Math.round(n * 100)); }
  function cents(n) { return money(n / 100); }
  function clean(s) { return String(s).replace(/\*$/, ''); }
  function shade(hex, amt) {
    var m = /^#?([0-9a-f]{6})$/i.exec(hex || ''); if (!m) return hex;
    var n = parseInt(m[1], 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255, t = amt < 0 ? 0 : 255, k = Math.abs(amt);
    r = Math.round((t - r) * k + r); g = Math.round((t - g) * k + g); b = Math.round((t - b) * k + b);
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

  /* ---------- products = Shopify data + Product styles ---------- */
  var LOOKS = {};
  (window.ZAPZ_LOOKS || []).forEach(function (l) { LOOKS[l.handle] = l; });
  var DEFAULT_BG = '#5A6B7A';
  var PRODUCTS = (Z.products || []).map(function (sp) {
    var c = LOOKS[sp.handle] || {};
    var parts = sp.title.split(' - ');
    var bg = c.bg || DEFAULT_BG, accent = c.accent || shade(bg, -0.25);
    var lines = String(c.benefits || '').split(/\r?\n/).map(function (x) { return x.trim(); }).filter(Boolean);
    var benefits = lines.map(function (x) { return x.split('|')[0].trim(); });
    var details = lines.map(function (x) { return (x.split('|')[1] || '').trim(); });
    var p = {
      id: sp.handle, name: parts[0].trim(), flavor: parts.length > 1 ? parts.slice(1).join(' - ').trim() : '',
      url: sp.url, price: sp.price / 100, variantId: sp.variantId, plan: sp.plan,
      ingredients: c.ingredients || '', goal: c.goal || 'Daily wellness', line: c.line || '', why: c.why || '', howTitle: c.howTitle || '', time: c.time || 'any', badge: c.badge || '',
      bg: bg, accent: accent, light: shade(bg, 0.28), dark: shade(bg, -0.2), tone: shade(accent, 0.9),
      benefits: benefits.length ? benefits : ['Daily support*', 'Great-tasting gummy', '30-day supply'], details: details,
      rawDesc: sp.desc || ''
    };
    p.soon = !!c.soon || p.price <= 0;
    p.available = !!sp.available && !p.soon;
    p.desc = p.rawDesc || p.line;
    p.line = p.line || (p.flavor ? p.flavor + ' flavor' : '');
    var imgs = sp.images || [];
    p.images = imgs.map(function (i) { return i.src; });
    p.cards = imgs.map(function (i) { return i.card || i.src; });
    p.thumb = imgs.length ? imgs[0].thumb : '';
    if (c.card) { p.cards = [c.card].concat(p.cards); p.thumb = c.cardThumb || c.card; }
    return p;
  });
  var LIVE = PRODUCTS.filter(function (p) { return p.available; });
  function byId(id) { for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].id === id) return PRODUCTS[i]; return null; }
  function handlesOf(root) {
    var h = (root.getAttribute('data-handles') || '').split(',').filter(Boolean);
    return h.length ? h.map(byId).filter(Boolean) : null;
  }
  function fullName(p) { return /gummies/i.test(p.name) ? p.name : p.name + ' Gummies'; }
  function hasSub(p) { return !!(p && p.plan); }
  function subOff(p) { return hasSub(p) ? (p.plan.pct || 0) / 100 : 0; }
  function perJar(p, n, sub) {
    if (sub && hasSub(p)) return p.price * (1 - subOff(p));
    return p.price * (1 - tierOff(n));
  }
  function tierOff(n) { var o = 0; SETTINGS.tiers.forEach(function (t) { if (n >= t.min) o = Math.max(o, t.off); }); return o; }
  function maxTier() { return SETTINGS.tiers.reduce(function (m, t) { return Math.max(m, t.off); }, 0); }
  function nextTier(n) { for (var i = 0; i < SETTINGS.tiers.length; i++) if (SETTINGS.tiers[i].min > n) return SETTINGS.tiers[i]; return null; }
  function tierText() { return SETTINGS.tiers.map(function (t, i) { return 'Save ' + Math.round(t.off * 100) + '% on ' + t.min + (i === SETTINGS.tiers.length - 1 ? '+' : '') + ' bottles'; }).join(' · '); }
  function packLabel(n) { return n + (n === 1 ? ' bottle' : ' bottles'); }
  function packNote(p, n, sub) {
    if (sub && hasSub(p)) return n === 1 ? 'Monthly' : n + ' each month';
    if (tierOff(n) > 0) return 'Save ' + Math.round(tierOff(n) * 100) + '%';
    return SETTINGS.daysPerJar * n + '-day supply';
  }
  function planCadence(p) {
    var name = hasSub(p) ? (p.plan.name || '').toLowerCase() : '';
    return 'Delivers ' + (/week/.test(name) ? 'every week' : /month/.test(name) ? 'monthly' : 'on schedule') + ' · skip or cancel anytime';
  }
  function bestSave(p) { return Math.max(Math.round(subOff(p) * 100), Math.round(maxTier() * 100)); }
  function ctaState(p) { return p.soon ? 'Coming soon' : !p.available ? 'Sold out' : ''; }
  function savePct(p, sel) { return Math.round((1 - perJar(p, sel.pack, sel.sub) / p.price) * 100); }
  function img(src, alt) { return '<img class="ph" src="' + src + '" alt="' + esc(alt) + '" loading="lazy">'; }
  function miniBottle(p) { return p.thumb ? '<img class="ph" src="' + p.thumb + '" alt="" loading="lazy">' : ''; }
  var STARS = '<span class="stars" aria-hidden="true">★★★★★</span>';
  var ICONS = {
    leaf: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 19c0-8 6-14 15-14 0 9-6 15-14 15"/><path d="M5 19 14 10"/></svg>',
    heart: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg>',
    spark: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z"/></svg>'
  };
  function themeRoot(el, p) {
    el.style.setProperty('--accent', p.accent);
    el.style.setProperty('--swatch', p.bg);
    el.style.setProperty('--tint', 'color-mix(in srgb, ' + p.accent + ' 13%, #FAF8F4)');
  }

  /* ---------- Shopify cart ---------- */
  var CART = Z.cart || { items: [], item_count: 0, total_price: 0 };
  function api(url, body) {
    var opts = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } };
    return fetch(url, opts).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Cart error'); return j; }); });
  }
  function refreshCart() { return api(R.cartJs).then(function (c) { CART = c; renderCart(); return c; }); }
  function setBusy(on) { var r = $('#cart'); if (r) r.classList.toggle('busy', !!on); }
  function addToCart(items, opts) {
    var payload = items.map(function (it) {
      var p = byId(it.id), o = { id: p.variantId, quantity: (it.pack || 1) * (it.qty || 1) };
      if (it.sub && hasSub(p)) o.selling_plan = p.plan.id;
      return o;
    });
    setBusy(true);
    return api(R.cartAdd, { items: payload }).then(refreshCart).then(function () { setBusy(false); if (!opts || opts.open !== false) openCart(); })
      .catch(function (e) { setBusy(false); toast(e.message || 'Could not add to cart'); });
  }
  function changeLine(key, qty) {
    setBusy(true);
    return api(R.cartChange, { id: key, quantity: Math.max(0, qty) }).then(function (c) { CART = c; renderCart(); setBusy(false); })
      .catch(function (e) { setBusy(false); toast(e.message || 'Could not update cart'); refreshCart(); });
  }

  /* ---------- header, menu, search ---------- */
  var annTimer = null;
  function bindHeader(root) {
    root = root || document;
    var spans = $$('.announce-msgs span', root), ai = 0;
    function showAnn(i) {
      if (!spans.length) return;
      ai = (i + spans.length) % spans.length;
      spans.forEach(function (s, j) { s.classList.toggle('on', j === ai); if (j === ai) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true'); });
    }
    function startAnn() { clearInterval(annTimer); if (spans.length > 1 && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) annTimer = setInterval(function () { showAnn(ai + 1); }, 4500); }
    $$('[data-ann]', root).forEach(function (b) { b.addEventListener('click', function () { showAnn(ai + (+b.getAttribute('data-ann'))); startAnn(); }); });
    var bar = $('.announce', root);
    if (bar) { bar.addEventListener('mouseenter', function () { clearInterval(annTimer); }); bar.addEventListener('mouseleave', startAnn); }
    startAnn();
    drawSearch('');
  }
  function drawSearch(q) {
    var box = $('[data-results]'), label = $('[data-results-label]');
    if (!box) return;
    q = q.trim().toLowerCase();
    var list = PRODUCTS.filter(function (p) { return !q || (p.name + ' ' + p.flavor + ' ' + p.goal + ' ' + p.line).toLowerCase().indexOf(q) >= 0; });
    label.textContent = q ? (list.length + (list.length === 1 ? ' result' : ' results')) : 'Shop by product';
    box.innerHTML = list.length ? list.map(function (p) {
      var price = p.soon ? '<span class="price">Coming soon</span>' : '<span class="price">' + money(perJar(p, 1, hasSub(p))) + (hasSub(p) ? '<s>' + money(p.price) + '</s>' : '') + '</span>';
      return '<a href="' + p.url + '"><span class="mthumb" style="background:' + p.tone + '">' + miniBottle(p) + '</span>' + esc(p.name) + price + '</a>';
    }).join('') : '<p class="menu-empty">No matches. Try “sleep”, “energy” or “berry”.</p>';
  }
  var menuFocus = null;
  function openMenu(search) {
    var root = $('#site-menu'); if (!root) return;
    menuFocus = document.activeElement;
    root.classList.add('open'); document.body.style.overflow = 'hidden';
    var t = $('[data-open-menu]'); if (t) t.setAttribute('aria-expanded', 'true');
    setTimeout(function () { var el = search ? $('[data-search]') : $('.menu-head .icon-btn'); if (el) el.focus(); }, 60);
  }
  function closeMenu() {
    var root = $('#site-menu'); if (!root || !root.classList.contains('open')) return;
    root.classList.remove('open'); document.body.style.overflow = '';
    var t = $('[data-open-menu]'); if (t) t.setAttribute('aria-expanded', 'false');
    if (menuFocus && menuFocus.focus) menuFocus.focus();
  }

  /* ---------- cart drawer ---------- */
  var lastFocus = null;
  function openCart() {
    var root = $('#cart'); if (!root) return;
    lastFocus = document.activeElement;
    root.classList.add('open'); document.body.style.overflow = 'hidden';
    setTimeout(function () { var b = $('.cart-head .icon-btn'); if (b) b.focus(); }, 50);
  }
  function closeCart() {
    var root = $('#cart'); if (!root || !root.classList.contains('open')) return;
    root.classList.remove('open'); document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }
  function lineHtml(it) {
    var p = byId(it.handle), tone = p ? p.tone : '#F1ECE4';
    var plan = it.selling_plan_allocation ? 'Subscription · ' + esc(it.selling_plan_allocation.selling_plan.name) : 'One-time purchase';
    var imgSrc = it.image ? it.image + (it.image.indexOf('?') > 0 ? '&' : '?') + 'width=200' : '';
    var name = it.product_title.split(' - ')[0], flavor = it.product_title.split(' - ')[1] || '';
    var was = it.original_line_price > it.final_line_price ? ' <s style="font-weight:400;color:var(--slate);font-size:13px">' + cents(it.original_line_price) + '</s>' : '';
    return '<div class="line" data-key="' + esc(it.key) + '">' +
      '<a class="thumb" href="' + it.url + '" style="background:' + tone + '">' + (imgSrc ? '<img class="ph" src="' + imgSrc + '" alt="">' : '') + '<span class="sr-only">' + esc(name) + '</span></a>' +
      '<div class="line-info"><div class="line-top"><a href="' + it.url + '">' + esc(name) + '</a><span>' + cents(it.final_line_price) + was + '</span></div>' +
      '<span class="plan">' + plan + '</span><span class="line-meta">' + (flavor ? esc(flavor) + ' · ' : '') + cents(it.final_price) + ' each</span>' +
      '<div class="line-actions"><div class="stepper">' +
      '<button type="button" aria-label="Decrease quantity of ' + esc(name) + '" data-line="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '">−</button>' +
      '<span aria-live="polite">' + it.quantity + '</span>' +
      '<button type="button" aria-label="Increase quantity of ' + esc(name) + '" data-line="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '">+</button>' +
      '</div><button type="button" class="text-btn" data-line="' + esc(it.key) + '" data-q="0">Remove</button></div></div></div>';
  }
  function renderCart() {
    var c = CART, items = c.items || [];
    var empty = '<div class="cart-empty"><span>Your cart is empty.</span><a class="btn btn-primary btn-sm" href="' + R.all + '">Shop all gummies</a></div>';
    var html = items.length ? items.map(lineHtml).join('') : empty;
    var inCart = function (id) { return items.some(function (x) { return x.handle === id; }); };
    var up = LIVE.filter(function (p) { return !inCart(p.id); })[0];
    if (up && items.length) {
      html += '<div class="upsell"><a class="thumb" href="' + up.url + '" style="background:' + up.tone + '">' + miniBottle(up) + '<span class="sr-only">' + esc(up.name) + '</span></a>' +
        '<div class="info"><span class="eyebrow">Pairs well with</span><span style="font-weight:500">' + esc(up.name) + '</span><span class="line-meta">' + money(perJar(up, 1, hasSub(up))) + (hasSub(up) ? ' / month with subscription' : '') + '</span></div>' +
        '<button type="button" class="btn btn-outline btn-sm" data-upsell="' + up.id + '">Add</button></div>';
    }
    var box = $('[data-cart-items]'); if (box) box.innerHTML = html;
    var subSave = 0;
    items.forEach(function (it) { var a = it.selling_plan_allocation; if (a && a.compare_at_price > a.price) subSave += (a.compare_at_price - a.price) * it.quantity; });
    var savings = subSave + (c.total_discount || 0);
    $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count || 0; });
    $$('[data-cart-badge]').forEach(function (el) { el.textContent = c.item_count || 0; el.classList.toggle('zero', !c.item_count); });
    $$('[data-cart-subtotal]').forEach(function (el) { el.textContent = cents(c.total_price || 0); });
    var sv = $('[data-cart-savings]'); if (sv) { sv.textContent = '−' + cents(savings); sv.parentNode.hidden = savings <= 0; }
    var ship = $('.ship'), bar = $('[data-ship-bar]'), msg = $('[data-ship-msg]');
    if (SETTINGS.freeShipping > 0) {
      var sub = (c.total_price || 0) / 100;
      if (ship) { ship.classList.remove('plain'); ship.hidden = false; }
      if (bar) bar.style.width = Math.min(100, Math.round(sub / SETTINGS.freeShipping * 100)) + '%';
      if (msg) msg.textContent = sub >= SETTINGS.freeShipping ? 'You’ve unlocked free shipping.' : 'You’re ' + money(SETTINGS.freeShipping - sub) + ' away from free shipping.';
    } else {
      if (ship) ship.classList.add('plain');
      var qty = c.item_count || 0, oneTime = items.some(function (it) { return !it.selling_plan_allocation; });
      var nx = nextTier(qty), need = nx ? nx.min - qty : 0;
      var bundle = nx && oneTime ? ' Add ' + need + ' more bottle' + (need === 1 ? '' : 's') + ' to save ' + Math.round(nx.off * 100) + '%.' : '';
      if (msg) msg.textContent = (SETTINGS.shipNote || '') + bundle;
      if (ship) ship.hidden = !(SETTINGS.shipNote || bundle);
    }
    var co = $('[data-checkout]'); if (co) co.disabled = !items.length;
    $$('[data-cart-page]').forEach(function (cp) { cp.innerHTML = items.length ? items.map(lineHtml).join('') : empty; });
  }

  function bindGlobal() {
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      if (t.closest('[data-open-cart]')) { e.preventDefault(); closeMenu(); openCart(); return; }
      if (t.closest('[data-open-menu]')) { openMenu(false); return; }
      if (t.closest('[data-open-search]')) { openMenu(true); return; }
      if (t.closest('[data-close-menu]')) { closeMenu(); return; }
      if (t.closest('#site-menu a[href]')) closeMenu();
      if (t.closest('[data-close-cart]')) { closeCart(); return; }
      var l = t.closest('[data-line]'); if (l) { changeLine(l.getAttribute('data-line'), +l.getAttribute('data-q')); return; }
      var qa = t.closest('[data-quick-add]'); if (qa) { var qp = byId(qa.getAttribute('data-quick-add')); if (qp) addToCart([{ id: qp.id, pack: 1, sub: hasSub(qp) }]); return; }
      var u = t.closest('[data-upsell]'); if (u) { var up = byId(u.getAttribute('data-upsell')); if (up) addToCart([{ id: up.id, pack: 1, sub: hasSub(up) }]); return; }
      if (t.closest('[data-checkout]')) { window.location.href = R.checkout; return; }
    });
    document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('[data-search]')) drawSearch(e.target.value); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
      var root = $('#cart');
      if (!root || !root.classList.contains('open')) return;
      if (e.key === 'Escape') { closeCart(); return; }
      if (e.key === 'Tab') {
        var f = $$('.cart-panel button, .cart-panel a[href]', root).filter(function (el) { return !el.disabled; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
  }

  /* ---------- configurator (cards + buy box) ---------- */
  function optsHtml(p, sel) {
    var o = '<div class="opts" role="group" aria-label="Purchase option">';
    if (hasSub(p)) o += '<button type="button" class="opt" data-sub="1" aria-pressed="' + sel.sub + '"><span class="opt-flag">Best value</span>' +
      '<span class="l"><span class="radio" aria-hidden="true"></span><span><span class="t">Subscribe &amp; save ' + Math.round(subOff(p) * 100) + '%</span><span class="s">' + planCadence(p) + '</span></span></span>' +
      '<span class="r"><span class="price" data-sub-price></span><span class="was" data-was></span></span></button>';
    o += '<button type="button" class="opt" data-sub="0" aria-pressed="' + !sel.sub + '"><span class="l" style="align-items:center"><span class="radio" aria-hidden="true" style="margin-top:0"></span><span class="t">One-time purchase</span></span><span class="price" data-one-price></span></button></div>';
    o += '<div class="packs" role="group" aria-label="Bottles">' + packsHtml(sel) + '</div>';
    return o;
  }
  function packsHtml(sel) {
    return SETTINGS.packs.map(function (n) { return '<button type="button" class="pack" data-pack="' + n + '" aria-pressed="' + (sel.pack === n) + '"><span class="t">' + packLabel(n) + '</span><span class="s" data-pack-note="' + n + '"></span></button>'; }).join('');
  }
  function wireConfigurator(root, p, sel, onChange) {
    function update() {
      $$('[data-sub]', root).forEach(function (b) { b.setAttribute('aria-pressed', String((b.getAttribute('data-sub') === '1') === sel.sub)); });
      $$('[data-pack]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-pack') === sel.pack)); });
      $$('[data-pack]', root).forEach(function (b) {
        var n = +b.getAttribute('data-pack'), off = sel.sub && hasSub(p) ? 0 : tierOff(n), tg = $('.pack-badge', b);
        if (!off) { if (tg) tg.remove(); return; }
        if (!tg) { tg = document.createElement('span'); tg.className = 'pack-badge'; b.appendChild(tg); }
        tg.textContent = (off >= maxTier() ? 'Best deal · ' : '') + '−' + Math.round(off * 100) + '%';
      });
      $$('[data-pack-note]', root).forEach(function (el) { el.textContent = packNote(p, +el.getAttribute('data-pack-note'), sel.sub); });
      $$('[data-sub-price]', root).forEach(function (el) { el.textContent = money(perJar(p, sel.pack, true)) + ' / bottle'; });
      $$('[data-was]', root).forEach(function (el) { el.textContent = money(p.price) + ' / bottle'; });
      $$('[data-one-price]', root).forEach(function (el) { el.textContent = money(perJar(p, sel.pack, false)) + ' / bottle'; });
      if (onChange) onChange();
    }
    root.addEventListener('click', function (e) {
      var s = e.target.closest('[data-sub]');
      if (s && root.contains(s)) { sel.sub = s.getAttribute('data-sub') === '1' && hasSub(p); update(); return; }
      var k = e.target.closest('[data-pack]');
      if (k && root.contains(k)) { sel.pack = +k.getAttribute('data-pack'); update(); }
    });
    update();
  }
  function productCard(p, defPackIdx) {
    var sel = { pack: SETTINGS.packs[Math.min(SETTINGS.packs.length - 1, (defPackIdx || 1) - 1)] || 1, sub: hasSub(p) };
    var el = document.createElement('article');
    el.className = 'pcard';
    el.style.setProperty('--accent', p.accent);
    var state = ctaState(p);
    el.innerHTML =
      '<a class="pcard-media' + (p.images.length ? ' has-photo' : '') + '" href="' + p.url + '" style="background:' + p.tone + '">' +
      '<span class="chip-tag">' + esc(p.goal) + '</span><span class="save" data-save></span>' + (p.images.length ? img(p.cards[0], p.name + ' gummies') : '') + '<span class="qty-badge" data-qtyb></span></a>' +
      '<div class="pcard-body"><div><div class="pcard-rating">' + STARS + (p.flavor ? '<span>' + esc(p.flavor) + '</span>' : '') + '</div><h3 class="pcard-title" style="margin-top:6px"><a href="' + p.url + '">' + esc(p.name) + '</a></h3><p class="pcard-line">' + esc(p.line) + '</p></div>' +
      (state ? '<p class="pcard-line" style="margin:0">' + esc(p.rawDesc || 'Launching soon — check back for details.') + '</p><a class="add-btn" href="' + p.url + '" style="text-decoration:none"><span>' + state + '</span><span>View →</span></a>'
        : optsHtml(p, sel) + '<button type="button" class="add-btn" data-add><span>Add to cart</span><span data-total></span></button>') + '</div>';
    if (!state) {
      wireConfigurator(el, p, sel, function () {
        var pct = savePct(p, sel), sv = $('[data-save]', el);
        sv.textContent = p.badge || 'Save ' + pct + '%'; sv.hidden = !p.badge && pct <= 0;
        var qb = $('[data-qtyb]', el); qb.textContent = '× ' + sel.pack; qb.hidden = sel.pack === 1;
        $('[data-total]', el).textContent = money(perJar(p, sel.pack, sel.sub) * sel.pack);
      });
      $('[data-add]', el).addEventListener('click', function () { addToCart([{ id: p.id, pack: sel.pack, sub: sel.sub }]); });
    } else { $('[data-save]', el).hidden = true; $('[data-qtyb]', el).hidden = true; }
    return el;
  }

  /* ---------- section initialisers ---------- */
  var INIT = {};
  var CLEANUP = {};

  INIT.hero = function (hero) {
    var cfg = [];
    try { cfg = JSON.parse(($('[data-slides]', hero) || {}).textContent || '[]'); } catch (e) {}
    var slides = cfg.map(function (s) { var p = byId(s.handle); return p ? { p: p, s: s } : null; }).filter(Boolean);
    if (!slides.length) slides = (LIVE.length ? LIVE : PRODUCTS).filter(function (p) { return p.images.length; }).map(function (p) { return { p: p, s: {} }; });
    var track = $('[data-hero-track]', hero), dots = $('[data-hero-dots]', hero);
    if (!slides.length) { track.innerHTML = '<div class="hslide on" style="--bg:#161616"><div class="wrap hs-inner"><div class="hs-copy"><h2>Add products to see the hero.</h2></div></div></div>'; return; }
    track.innerHTML = slides.map(function (x, i) {
      var p = x.p, s = x.s, bg = s.bg || p.bg, im = s.image || p.images[0];
      var heading = s.heading || fullName(p);
      var lead = String(s.text || p.desc || '').split(/(?<=[.!?])\s+/)[0];
      return '<div class="hslide' + (s.align === 'right' ? ' txt-right' : '') + (i === 0 ? ' on' : '') + '" role="group" aria-roledescription="slide" aria-label="' + (i + 1) + ' of ' + slides.length + ': ' + esc(p.name) + '" style="--bg:' + bg + ';--bg-light:' + shade(bg, 0.28) + ';--bg-dark:' + shade(bg, -0.2) + '"' + (i === 0 ? '' : ' aria-hidden="true" inert') + ' ' + (s.attrs || '') + '>' +
        (im ? '<div class="hs-full"><img src="' + im + '" alt="Zapz ' + esc(p.name) + ' Gummies"' + (i === 0 ? ' fetchpriority="high"' : ' loading="lazy"') + '></div>' : '') +
        '<div class="wrap hs-inner"><div class="hs-copy"><span class="chip-tag">' + esc(p.goal) + (p.flavor ? ' · ' + esc(p.flavor) : '') + '</span>' +
        '<h2' + (heading.length > 22 ? ' class="long"' : '') + '>' + esc(heading) + '</h2><p>' + esc(s.text || p.desc) + '</p>' +
        '<ul class="checklist">' + p.benefits.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('') + '</ul>' +
        (p.soon ? '<span class="price-note"><strong>Coming soon</strong></span>' : '<span class="price-note">' + (hasSub(p) ? 'From <strong>' + money(perJar(p, 1, true)) + '</strong> / month with subscription' : '<strong>' + money(p.price) + '</strong>') + '</span>') +
        '<div class="cta-row"><a class="btn btn-white" href="' + p.url + '">' + esc(s.button || 'Shop ' + p.name) + '</a>' + (p.available ? '<button type="button" class="btn btn-ghost" data-quick-add="' + p.id + '">Add to cart</button>' : '') + '</div></div>' +
        '</div></div>';
    }).join('');
    dots.innerHTML = slides.map(function (x) { return '<button type="button" aria-label="Show ' + esc(x.p.name) + '"><span><i></i></span></button>'; }).join('');
    var els = $$('.hslide', track), dbtn = $$('button', dots), cur = 0, timer = null, MS = +(hero.getAttribute('data-ms') || 7000);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var paused = reduce || els.length < 2 || hero.getAttribute('data-autoplay') === 'false' || !!window.Shopify && !!window.Shopify.designMode, hovering = false;
    hero.style.setProperty('--hs-ms', MS + 'ms');
    function restart() {
      clearTimeout(timer); hero.classList.remove('playing'); void hero.offsetWidth;
      if (!paused && !hovering) { hero.classList.add('playing'); timer = setTimeout(function () { show(cur + 1); }, MS); }
    }
    function show(i) {
      cur = (i + els.length) % els.length;
      els.forEach(function (s, j) { var on = j === cur; s.classList.toggle('on', on); if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('inert'); } else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); } });
      dbtn.forEach(function (b, j) { b.setAttribute('aria-current', String(j === cur)); });
      restart();
    }
    dbtn.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });
    $('[data-hero-prev]', hero).addEventListener('click', function () { show(cur - 1); });
    $('[data-hero-next]', hero).addEventListener('click', function () { show(cur + 1); });
    var pb = $('[data-hero-pause]', hero);
    function syncPause() { pb.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow'); $('[data-icon-pause]', pb).hidden = paused; $('[data-icon-play]', pb).hidden = !paused; }
    pb.addEventListener('click', function () { paused = !paused; syncPause(); restart(); });
    hero.addEventListener('mouseenter', function () { hovering = true; restart(); });
    hero.addEventListener('mouseleave', function () { hovering = false; restart(); });
    hero.addEventListener('focusin', function () { hovering = true; restart(); });
    hero.addEventListener('focusout', function (e) { if (!hero.contains(e.relatedTarget)) { hovering = false; restart(); } });
    $('.hs-controls', hero).hidden = els.length < 2;
    syncPause(); show(0);
    hero._select = function (blockId) { els.forEach(function (s, i) { if ((s.getAttribute('data-shopify-editor-block') || '').indexOf(blockId) >= 0) show(i); }); };
    CLEANUP[hero.closest('.shopify-section') ? hero.closest('.shopify-section').id : 'hero'] = function () { clearTimeout(timer); };
  };

  INIT.explore = function (sec) {
    var track = $('[data-ex-track]', sec), currentId = Z.current;
    var list = (handlesOf(sec) || PRODUCTS).slice();
    if (currentId) list.sort(function (a, b) { return (b.id === currentId) - (a.id === currentId); });
    track.innerHTML = list.map(function (p) {
      var cur = p.id === currentId, state = ctaState(p);
      var price = p.soon ? 'Launching soon' : (hasSub(p) ? 'From <strong>' + money(perJar(p, 1, true)) + '</strong>/mo' : '<strong>' + money(p.price) + '</strong>');
      var action = state ? '<a class="ex-go" href="' + p.url + '" aria-label="View ' + esc(p.name) + '">→</a>' : '<button type="button" class="ex-add" data-quick-add="' + p.id + '" aria-label="Add ' + esc(p.name) + ' to cart">+</button>';
      return '<article class="ex-card' + (cur ? ' current' : '') + '" style="--tone:' + p.tone + ';--accent:' + p.accent + ';--swatch:' + p.bg + '">' +
        '<a class="media" href="' + p.url + '" tabindex="-1" aria-hidden="true">' + (p.images.length ? '<img src="' + p.cards[0] + '" alt="" loading="lazy">' : '') +
        (cur ? '<span class="viewing">Viewing now</span>' : state ? '<span class="viewing">' + state + '</span>' : '<span class="tag">' + esc(p.goal) + '</span>') + '</a>' +
        '<div class="body"><a class="t" href="' + p.url + '"><h3>' + esc(p.name) + '</h3><p>' + esc(p.flavor || p.line) + '</p></a>' +
        '<div class="row"><span class="price">' + price + '</span>' + action + '</div></div></article>';
    }).join('');
    function step(d) { track.scrollBy({ left: d * Math.max(276, track.clientWidth * 0.8), behavior: 'smooth' }); }
    var prev = $('[data-ex-prev]', sec), next = $('[data-ex-next]', sec);
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  };

  INIT.goals = function (gg) {
    var goals = [];
    PRODUCTS.forEach(function (p) { if (goals.indexOf(p.goal) < 0) goals.push(p.goal); });
    gg.innerHTML = goals.map(function (g) {
      var items = PRODUCTS.filter(function (p) { return p.goal === g; });
      var ph = items.filter(function (p) { return p.images.length; })[0];
      var href = R.all + '?goal=' + encodeURIComponent(g);
      var count = items.length === 1 ? (items[0].soon ? 'Coming soon' : items[0].flavor || '1 formula') : items.length + ' formulas';
      return '<a class="goal' + (ph ? ' has-photo' : '') + '" href="' + href + '">' + (ph ? '<img src="' + ph.cards[0] + '" alt="" loading="lazy">' : '') + '<span class="name">' + esc(g) + '</span><span class="count">' + esc(count) + '</span></a>';
    }).join('');
  };

  INIT.grid = function (root) {
    var grid = $('[data-grid]', root), filters = $('[data-filters]', root), countEl = $('[data-count]', root);
    var pool = handlesOf(root) || PRODUCTS, defPack = +root.getAttribute('data-default-pack') || 1;
    var goals = ['All'];
    pool.forEach(function (p) { if (goals.indexOf(p.goal) < 0) goals.push(p.goal); });
    var params = new URLSearchParams(window.location.search);
    var current = goals.indexOf(params.get('goal')) >= 0 ? params.get('goal') : 'All';
    var showFilters = root.getAttribute('data-filters-on') !== 'false' && goals.length > 2;
    filters.innerHTML = showFilters ? goals.map(function (g) { return '<button type="button" class="chip" data-goal="' + esc(g) + '">' + esc(g) + '</button>'; }).join('') : '';
    function draw() {
      $$('[data-goal]', filters).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-goal') === current)); });
      grid.innerHTML = '';
      var shown = pool.filter(function (p) { return current === 'All' || p.goal === current; });
      shown.sort(function (a, b) { return (b.available ? 1 : 0) - (a.available ? 1 : 0); });
      shown.forEach(function (p) { grid.appendChild(productCard(p, defPack)); });
      countEl.textContent = shown.length + (shown.length === 1 ? ' formula' : ' formulas');
    }
    filters.addEventListener('click', function (e) {
      var b = e.target.closest('[data-goal]'); if (!b) return;
      current = b.getAttribute('data-goal');
      try { var url = new URL(window.location.href); if (current === 'All') url.searchParams.delete('goal'); else url.searchParams.set('goal', current); window.history.replaceState(null, '', url); } catch (err) {}
      draw();
    });
    draw();
  };

  INIT.stack = function (root) {
    var btn = $('[data-stack]', root); if (!btn) return;
    var ids = (btn.getAttribute('data-stack') || '').split(',').map(byId).filter(function (p) { return p && p.available; });
    if (ids.length < 2) ids = LIVE.slice(0, 2);
    if (ids.length < 2) { btn.disabled = true; return; }
    btn.addEventListener('click', function () { addToCart(ids.map(function (p) { return { id: p.id, pack: 1, sub: hasSub(p) }; })); });
  };

  INIT.product = function (root) {
    var p = byId(root.getAttribute('data-product')); if (!p) return;
    var isMain = root.getAttribute('data-main') === 'true';
    var sel = { pack: SETTINGS.packs[0] || 1, sub: hasSub(p), qty: 1 }, state = ctaState(p);
    themeRoot(root, p);
    if (isMain) themeRoot(document.documentElement, p);
    $$('[data-p-goal]', root).forEach(function (el) { el.textContent = p.goal; });
    var badge = $('[data-p-badge]', root);
    if (badge) { if (state) { badge.textContent = state; badge.className = 'soon-tag'; badge.hidden = false; } else if (p.badge || bestSave(p) > 0) { badge.textContent = p.badge || 'Save up to ' + bestSave(p) + '%'; badge.hidden = false; } }
    var crumb = $('[data-crumb-goal]', root); if (crumb) { crumb.textContent = p.goal; crumb.href = R.all + '?goal=' + encodeURIComponent(p.goal); }
    var ki = $('[data-key-ing]', root); if (ki) { ki.hidden = !p.ingredients; $('[data-key-ing-list]', ki).textContent = p.ingredients; }
    var ben = $('[data-benefits]', root); if (ben) ben.innerHTML = p.benefits.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('');

    // gallery (markup is rendered by Liquid)
    var track = $('[data-slides]', root), gthumbs = $('[data-gthumbs]', root), dots = $('[data-dots]', root);
    var slides = track ? $$('.slide', track) : [], n = slides.length, current = 0;
    function mark(i) {
      current = i;
      if (gthumbs) $$('button', gthumbs).forEach(function (b, j) { b.setAttribute('aria-current', String(i === j)); });
      if (dots) $$('button', dots).forEach(function (b, j) { b.setAttribute('aria-current', String(i === j)); });
    }
    function sw() { return slides[0] ? slides[0].getBoundingClientRect().width : track.clientWidth; }
    function perView() { return Math.max(1, Math.round(track.clientWidth / Math.max(1, sw()))); }
    function go(i) { var max = Math.max(0, n - perView()); i = (i + n) % n; track.scrollTo({ left: Math.min(i, max) * sw(), behavior: 'smooth' }); mark(i); }
    if (n > 1) {
      if (gthumbs) $$('button', gthumbs).forEach(function (b, i) { b.addEventListener('click', function () { go(i); }); });
      if (dots) $$('button', dots).forEach(function (b, i) { b.addEventListener('click', function () { go(i); }); });
      var pv = $('[data-prev]', root), nx = $('[data-next]', root);
      if (pv) pv.addEventListener('click', function () { go(current - 1); });
      if (nx) nx.addEventListener('click', function () { go(current + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      });
      var st;
      track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { var i = Math.round(track.scrollLeft / Math.max(1, sw())); if (i !== current) mark(i); }, 80); });
      window.addEventListener('resize', function () { track.scrollLeft = Math.min(current, Math.max(0, n - perView())) * sw(); });
    }

    // buy box
    var panel = $('[data-buy]', root);
    if (panel) {
      var tabs = $('[data-plan-tabs]', panel);
      tabs.innerHTML = (hasSub(p) ? '<button type="button" data-sub="1" aria-pressed="true">Subscribe &amp; save<span class="tag tag-best">Best value · Save ' + Math.round(subOff(p) * 100) + '%</span></button>' : '') + '<button type="button" data-sub="0" aria-pressed="' + !hasSub(p) + '">One-time purchase' + (maxTier() > 0 ? '<span class="tag tag-soft">Save up to ' + Math.round(maxTier() * 100) + '%</span>' : '') + '</button>';
      if (!hasSub(p)) tabs.style.gridTemplateColumns = '1fr';
      $('[data-packs]', panel).innerHTML = packsHtml(sel);
      var qtyEl = $('[data-qty-val]', panel);
      var totals = function () {
        var per = perJar(p, sel.pack, sel.sub), pct = savePct(p, sel);
        $$('[data-p-total]', root).forEach(function (el) { el.textContent = state ? '' : money(per * sel.pack * sel.qty); });
        $$('[data-p-now]', root).forEach(function (el) { el.textContent = p.soon ? 'Coming soon' : money(per); });
        $$('[data-p-per]', root).forEach(function (el) { el.textContent = p.soon ? '' : sel.sub ? '/mo' : '/bottle'; });
        $$('[data-p-was]', root).forEach(function (el) { el.textContent = money(p.price); el.hidden = pct <= 0 || p.soon; });
        $$('[data-p-save]', root).forEach(function (el) { el.textContent = 'Save ' + pct + '%'; el.hidden = pct <= 0 || p.soon; });
        var yearly = hasSub(p) ? p.price * subOff(p) * sel.pack * 12 : 0;
        $$('[data-p-year]', root).forEach(function (el) {
          el.textContent = p.soon ? '' : !hasSub(p) ? (SETTINGS.tiers.length ? tierText() + '.' : '') :
            sel.sub ? 'You save ' + money(yearly) + ' a year with a subscription.' : 'Subscribe & save ' + money(yearly) + ' a year.';
        });
        $$('[data-p-fine]', root).forEach(function (el) {
          el.textContent = p.soon ? 'This formula is launching soon.' : sel.sub ? '*' + planCadence(p) + '. Billed per delivery.' :
            '*One-time order of ' + packLabel(sel.pack * sel.qty) + '.' + (tierOff(sel.pack * sel.qty) > 0 ? ' ' + Math.round(tierOff(sel.pack * sel.qty) * 100) + '% off applied at checkout.' : '');
        });
        var meta = p.soon ? 'Coming soon' : (sel.sub ? 'Subscribe · ' : 'One-time · ') + packLabel(sel.pack) + (sel.qty > 1 ? ' × ' + sel.qty : '');
        $$('[data-p-meta]', root).forEach(function (el) { el.textContent = meta; });
        if (qtyEl) qtyEl.textContent = sel.qty;
        var df = $('[data-dyn-form]', root);
        if (df) {
          $('[data-dyn-qty]', df).value = sel.pack * sel.qty;
          var dp = $('[data-dyn-plan]', df), useSub = sel.sub && hasSub(p);
          dp.value = useSub ? p.plan.id : ''; dp.disabled = !useSub;
          if (p.variantId) $('[data-dyn-id]', df).value = p.variantId;
          df.hidden = !!state;
        }
      };
      wireConfigurator(panel, p, sel, totals);
      var dec = $('[data-qty-dec]', panel), inc = $('[data-qty-inc]', panel);
      if (dec) dec.addEventListener('click', function () { sel.qty = Math.max(1, sel.qty - 1); totals(); });
      if (inc) inc.addEventListener('click', function () { sel.qty = Math.min(20, sel.qty + 1); totals(); });
      $$('[data-p-add]', root).forEach(function (b) {
        if (state) { b.disabled = true; b.textContent = state; if (p.soon && b.closest('.buy-panel')) b.closest('.buy-row').hidden = true; return; }
        b.addEventListener('click', function () { addToCart([{ id: p.id, pack: sel.pack, sub: sel.sub, qty: sel.qty }]); });
      });
      totals();
      var nf = $('[data-notify]', root);
      if (nf && p.soon) { nf.hidden = false; $$('[data-plan-tabs], [data-packs]', panel).forEach(function (el) { el.parentNode.hidden = true; }); }
    }
    var sticky = $('[data-sticky]', root), anchor = panel ? $('[data-p-add]', panel) : null;
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { var e = entries[0]; sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(anchor);
    }
  };

  INIT.research = function (sec) {
    var p = byId(sec.getAttribute('data-product'));
    if (p) { themeRoot(sec, p); var w = $('[data-why]', sec); if (w && p.why) w.textContent = p.why; }
    var tabs = $$('[role="tab"]', sec), panels = $$('[role="tabpanel"]', sec);
    function show(i) {
      tabs.forEach(function (b, j) { b.setAttribute('aria-selected', String(i === j)); b.tabIndex = i === j ? 0 : -1; });
      panels.forEach(function (pn, j) { pn.hidden = i !== j; });
    }
    tabs.forEach(function (b, i) {
      b.addEventListener('click', function () { show(i); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); var j = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length; show(j); tabs[j].focus(); }
      });
    });
    sec._select = function (blockId) { tabs.forEach(function (b, i) { if (b.id === 'rtab-' + blockId) show(i); }); };
  };

  INIT.how = function (sec) {
    var p = byId(sec.getAttribute('data-product')); if (!p) return;
    themeRoot(sec, p);
    var mh = $('[data-how-title]', sec); if (mh && !mh.textContent.trim()) mh.textContent = p.howTitle || (clean(p.benefits[0]) + '. ' + clean(p.benefits[1] || '') + '.');
    var core = $('.core', sec); if (core) core.style.background = p.tone;
    var rs = $('[data-reasons]', sec);
    if (rs && !rs._init) {
      rs._init = true;
      var tr = $('[data-rs-track]', rs), sl = $$('.rs-slide', tr), dt = $('[data-rs-dots]', rs), idx = 0, tm = null;
      dt.innerHTML = sl.map(function (x, i) { return '<button type="button" aria-label="Show photo ' + (i + 1) + '"></button>'; }).join('');
      var db = $$('button', dt);
      var markR = function (i) { idx = i; db.forEach(function (b, j) { b.setAttribute('aria-current', String(i === j)); }); };
      var goR = function (i) { i = (i + sl.length) % sl.length; tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' }); markR(i); };
      db.forEach(function (b, i) { b.addEventListener('click', function () { goR(i); restartR(); }); });
      var st; tr.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { var i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)); if (i !== idx) markR(i); }, 80); });
      var reduceR = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var restartR = function () { clearInterval(tm); if (!reduceR && sl.length > 1) tm = setInterval(function () { goR(idx + 1); }, 3800); };
      rs.addEventListener('pointerenter', function () { clearInterval(tm); }); rs.addEventListener('pointerleave', restartR);
      tr.addEventListener('touchstart', function () { clearInterval(tm); }, { passive: true });
      markR(0); restartR();
    }
    ['a', 'b', 'c'].forEach(function (k, i) {
      var card = $('[data-mech-' + k + ']', sec); if (!card) return;
      var bn = clean(p.benefits[i] || 'Daily support');
      var tpl = sec.getAttribute('data-card-' + (i + 1)) || '';
      var body = (p.details && p.details[i]) || tpl.replace(/\[benefit\]/g, bn.toLowerCase());
      card.innerHTML = '<span class="ic">' + [ICONS.leaf, ICONS.heart, ICONS.spark][i] + '</span><h3>' + esc(bn) + '</h3><p>' + esc(body) + '</p>';
    });
  };

  INIT.quiz = function (root) {
    var A = function (k, d) { return root.getAttribute('data-' + k) || d; };
    var HT = A('heading-tag', 'h2');
    var pool = LIVE.length ? LIVE : PRODUCTS;
    var goals = [];
    pool.forEach(function (p) { if (goals.indexOf(p.goal) < 0) goals.push(p.goal); });
    var anySub = pool.some(hasSub);
    var subPct = Math.max.apply(null, pool.map(function (p) { return Math.round(subOff(p) * 100); }).concat([0]));
    var bundlePct = Math.round(maxTier() * 100);
    var goalStep = { key: 'goals', multi: true, q: A('q1', 'What do you need support with?'), hint: A('h1', ''), opts: goals.map(function (g) { var p = pool.filter(function (x) { return x.goal === g; })[0]; return { v: g, label: g, sw: p.bg }; }) };
    var pathStep = { key: 'path', q: A('qpath', 'How would you like to shop?'), hint: A('hpath', 'Bundle your gummies and save, or read up on each one first.'), opts: [
      { v: 'bundle', label: 'Build a bundle' + (anySub || bundlePct ? ' & save' : '') },
      { v: 'learn', label: 'Learn more about my gummies' }
    ] };
    // personalised follow-ups, built from the goal combination
    function cat(g) {
      var t = (g + ' ' + pool.filter(function (x) { return x.goal === g; }).map(function (x) { return x.name; }).join(' ')).toLowerCase();
      if (/sleep|relax|calm/.test(t)) return 'sleep';
      if (/energy|focus/.test(t)) return 'energy';
      if (/hair|skin|nail|beauty/.test(t)) return 'beauty';
      if (/period|cycle|pms|menstrual/.test(t)) return 'period';
      if (/multi|essential/.test(t)) return 'multi';
      if (/balance|wellness|daily/.test(t)) return 'balance';
      return 'other';
    }
    var VIBES = {
      energy: ['My afternoons tend to drag', 'I juggle a packed schedule', 'I want to stay sharp for work or study'],
      sleep: ['I find it hard to switch off at night', 'My evenings feel rushed and wired', 'I want a calmer wind-down routine'],
      beauty: ['I want my hair to look its best', 'Skin and nails are part of my self-care', 'I want a beauty routine that’s easy'],
      period: ['My cycle throws off my week', 'I want that time of the month to feel easier', 'I like to plan ahead for my cycle'],
      multi: ['I don’t always eat balanced meals', 'I want one simple daily basic', 'I’m always on the go'],
      balance: ['I’m building healthier habits', 'I’m into fitness and routines', 'I want something I’ll actually stick with'],
      other: ['I want a simple daily routine', 'I want something tasty I’ll stick with']
    };
    var VIBE_Q = {
      energy: 'What does a typical day look like?', sleep: 'How do your evenings usually go?', beauty: 'What’s your beauty routine like?',
      period: 'How does your cycle affect your month?', multi: 'What’s your day-to-day like?', balance: 'Where are you with your wellness routine?', other: 'Which of these sounds like you?'
    };
    var COMBOS = [
      { has: ['energy', 'sleep'], v: 'daynight', label: 'An easy day-and-night routine', line: 'Your gummies are split into a morning and an evening routine.' },
      { has: ['beauty', 'period'], v: 'month', label: 'Self-care that covers the whole month', line: 'Your routine covers everyday self-care and your monthly cycle.' },
      { has: ['sleep', 'period'], v: 'cozy', label: 'Cozy, low-stress evenings', line: 'Your evening routine is built around winding down.' },
      { has: ['energy', 'multi'], v: 'busy', label: 'Covering the basics on busy days', line: 'Your routine is built for busy days.' },
      { has: ['balance', 'multi'], v: 'basics', label: 'A healthy foundation I’ll stick to', line: 'Your routine pairs your daily basics with your healthy habits.' },
      { has: ['beauty', 'multi'], v: 'selfcare', label: 'A full self-care routine in two steps', line: 'Your routine pairs daily essentials with beauty support.' },
      { has: ['energy', 'balance'], v: 'active', label: 'Keeping up with an active lifestyle', line: 'Your routine is built around an active lifestyle.' },
      { has: ['energy', 'beauty'], v: 'glow', label: 'Looking and feeling ready for the day', line: 'Your morning routine covers energy and beauty in one go.' },
      { has: ['sleep', 'beauty'], v: 'night', label: 'An evening self-care ritual', line: 'Your evening routine doubles as self-care.' },
      { has: ['period', 'energy'], v: 'steady', label: 'Staying on track all month', line: 'Your routine is built to keep your month on track.' }
    ];
    var PRIOS = [
      { v: 'taste', label: 'It has to taste great', line: 'Every Zapz gummy is made with real fruit flavor, so it tastes like a treat.' },
      { v: 'simple', label: 'Keep it simple', line: 'It’s just two gummies a day per formula, nothing complicated.' },
      { v: 'clean', label: 'Clean ingredients', line: 'Every formula is vegan, gluten-free and non-GMO with zero artificial colors.' },
      { v: 'value', label: 'The best value', line: 'We’ve set you up with the best price. Subscribe & save, or bundle bottles for extra savings.' }
    ];
    function cats() { var c = []; ans.goals.forEach(function (g) { var k = cat(g); if (c.indexOf(k) < 0) c.push(k); }); return c; }
    function combo() { var c = cats(); return COMBOS.filter(function (x) { return x.has.every(function (k) { return c.indexOf(k) >= 0; }); })[0]; }
    function steps() {
      var c = cats(), one = c.length === 1;
      var vopts = [];
      c.forEach(function (k) { (VIBES[k] || VIBES.other).slice(0, one ? 3 : (c.length > 3 ? 1 : 2)).forEach(function (l, i) { vopts.push({ v: k + i, label: l }); }); });
      if (!vopts.length) vopts = VIBES.other.map(function (l, i) { return { v: 'other' + i, label: l }; });
      var vibe = { key: 'vibe', multi: true, q: one ? VIBE_Q[c[0]] : c.length ? 'Which of these sound like you?' : VIBE_Q.other, hint: 'Pick everything that applies, so we can personalize your routine.', opts: vopts };
      var cb = combo(), popts = [];
      if (cb) popts.push({ v: cb.v, label: cb.label });
      if (c.length >= 3) popts.push({ v: 'allinone', label: 'One routine for everything, without the pill pile' });
      popts = popts.concat(PRIOS.map(function (x) { return { v: x.v, label: x.label }; }));
      var nm = one ? (pool.filter(function (x) { return ans.goals.indexOf(x.goal) >= 0; })[0] || {}).name : '';
      var prio = { key: 'prio', q: one && ans.goals.length === 1 ? 'What matters most in your ' + ans.goals[0].toLowerCase() + ' routine?' : 'What matters most in your routine?', hint: 'We’ll tailor your picks around it.', opts: popts };
      var list = [goalStep, vibe, prio];
      if (picksFor().length !== 1) list.push(pathStep);
      return list;
    }
    function you(t) {
      return t.replace(/\bI’m\b/g, 'you’re').replace(/\bI don’t\b/g, 'you don’t').replace(/\bI’ll\b/g, 'you’ll').replace(/\bI\b/g, 'you').replace(/\b[Mm]y\b/g, 'your').replace(/^./, function (c) { return c.toLowerCase(); });
    }
    function personalLine() {
      var bits = [], vl = [];
      steps()[1].opts.forEach(function (o) { if (ans.vibe.indexOf(o.v) >= 0) vl.push(you(o.label)); });
      if (vl.length) bits.push('You said ' + vl.slice(0, 2).join(' and ') + '.');
      var cb = combo(), pr = PRIOS.filter(function (x) { return x.v === ans.prio; })[0];
      if (ans.prio === 'allinone') bits.push('All your picks are in one routine, two gummies each.');
      else if (cb && ans.prio === cb.v) bits.push(cb.line);
      else if (pr) bits.push(pr.line);
      return bits.join(' ');
    }
    var ans = { goals: [], vibe: [], prio: null, path: null }, step = 0;
    function picksFor() { return pool.filter(function (p) { return ans.goals.indexOf(p.goal) >= 0; }); }
    function markSeen() { try { localStorage.setItem('zapzQuizSeen', '1'); sessionStorage.setItem('zapzQuizClosed', '1'); } catch (e) {} }
    var bundle = { qty: {}, order: [], sub: anySub };
    var bar = $('[data-quiz-bar]', root), body = $('[data-quiz-body]', root);
    function ok() { var s = steps()[step]; return s.multi ? ans[s.key].length > 0 : !!ans[s.key]; }
    function draw(focus) {
      var ST = steps(), total = ans.goals.length ? ST.length : 4;
      bar.style.width = (Math.min(step, total) / total * 100) + '%';
      if (step >= ST.length) return ans.path === 'learn' ? learn(true) : results(true);
      var s = ST[step];
      var chosen = function (v) { return s.multi ? ans[s.key].indexOf(v) >= 0 : ans[s.key] === v; };
      body.innerHTML = '<div class="quiz-step"><p class="eyebrow" style="margin:0 0 10px">Question ' + (step + 1) + ' of ' + total + '</p>' +
        '<' + HT + ' tabindex="-1">' + esc(s.q) + '</' + HT + '>' + (s.hint ? '<p class="hint">' + esc(s.hint) + '</p>' : '') +
        '<div class="q-options" role="group" aria-label="' + esc(s.q) + '">' + s.opts.map(function (o) {
          return '<button type="button" class="q-opt' + (s.multi ? '' : ' radio-opt') + '" data-v="' + esc(o.v) + '" aria-pressed="' + chosen(o.v) + '"><span class="dot" aria-hidden="true"></span>' + esc(o.label) + (o.sw ? '<span class="sw" style="background:' + o.sw + '" aria-hidden="true"></span>' : '') + '</button>';
        }).join('') + '</div>' +
        '<div class="quiz-nav">' + (step > 0 ? '<button type="button" class="btn btn-outline" data-q-back>Back</button>' : '<span></span>') +
        '<button type="button" class="btn btn-primary" data-q-next' + (ok() ? '' : ' disabled') + '>' + (step === ST.length - 1 ? (picksFor().length === 1 ? 'See my gummy' : 'Show my results') : 'Continue') + '</button></div></div>';
      var h = $(HT, body); if (h && focus) h.focus();
    }
    function startBundle() {
      var picks = picksFor();
      bundle = { qty: {}, order: [], sub: anySub };
      var cb = combo();
      if (cb && ans.prio === cb.v && cb.v === 'daynight') picks.sort(function (a, b) { return (a.time === 'pm') - (b.time === 'pm'); });
      picks.forEach(function (p) { bundle.qty[p.id] = 1; bundle.order.push(p.id); });
    }
    function lineCalc() {
      var rows = bundle.order.map(byId).filter(function (p) { return p && bundle.qty[p.id] > 0; });
      var onceQty = rows.reduce(function (n, p) { return n + (bundle.sub && hasSub(p) ? 0 : bundle.qty[p.id]); }, 0);
      var bOff = tierOff(onceQty), bundleOn = bOff > 0;
      var full = 0, total = 0, bottles = 0;
      var unit = {};
      rows.forEach(function (p) {
        var q = bundle.qty[p.id], u = bundle.sub && hasSub(p) ? p.price * (1 - subOff(p)) : p.price * (1 - bOff);
        unit[p.id] = u; full += p.price * q; total += u * q; bottles += q;
      });
      return { rows: rows, unit: unit, full: full, total: total, bottles: bottles, bundleOn: bundleOn, bOff: bOff, anySubLine: rows.some(function (p) { return bundle.sub && hasSub(p); }) };
    }
    function results(focus) {
      bar.style.width = '100%';
      var c = lineCalc();
      var extras = pool.filter(function (p) { return bundle.order.indexOf(p.id) < 0 || !bundle.qty[p.id]; });
      var rowsHtml = bundle.order.map(byId).filter(Boolean).map(function (p) {
        var q = bundle.qty[p.id] || 0; if (!q) return '';
        var subLine = bundle.sub && hasSub(p);
        var note = subLine ? 'Delivered monthly · ' + Math.round(subOff(p) * 100) + '% off' : (bundle.sub && !hasSub(p) ? 'One-time · subscription not available' : (c.bundleOn ? 'One-time · ' + Math.round(c.bOff * 100) + '% bundle discount' : 'One-time'));
        var fits = ans.goals.indexOf(p.goal) >= 0 ? 'Matches: ' + p.goal : 'Added by you';
        return '<div class="qb-row" style="--accent:' + p.accent + ';--tone:' + p.tone + '">' +
          '<a class="qb-media" href="' + p.url + '" tabindex="-1" aria-hidden="true">' + (p.cards.length ? '<img src="' + p.cards[0] + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="qb-info"><span class="qb-why">' + esc(fits) + '</span><a class="qb-name" href="' + p.url + '">' + esc(fullName(p)) + '</a><span class="qb-note">' + esc(note) + '</span></div>' +
          '<div class="qb-ctrl"><div class="qb-price"><strong>' + money(c.unit[p.id] * q) + '</strong>' + (c.unit[p.id] < p.price ? '<s>' + money(p.price * q) + '</s>' : '') + '</div>' +
          '<div class="stepper" role="group" aria-label="Bottles of ' + esc(p.name) + '"><button type="button" data-qb="' + p.id + '" data-d="-1" aria-label="' + (q === 1 ? 'Remove ' : 'One fewer ') + esc(p.name) + '">' + (q === 1 ? '×' : '−') + '</button><span aria-live="polite">' + q + '</span><button type="button" data-qb="' + p.id + '" data-d="1" aria-label="One more ' + esc(p.name) + '">+</button></div></div></div>';
      }).join('');
      var mode = anySub ? '<div class="qb-mode" role="group" aria-label="Purchase option">' +
        '<button type="button" data-qmode="sub" aria-pressed="' + bundle.sub + '"><span>Subscribe &amp; save ' + subPct + '%</span><small>Monthly delivery · skip or cancel anytime</small></button>' +
        '<button type="button" data-qmode="once" aria-pressed="' + !bundle.sub + '"><span>One-time purchase</span><small>' + (SETTINGS.tiers.length ? tierText() : 'No commitment') + '</small></button></div>' : '';
      var save = c.full - c.total;
      body.innerHTML = '<div class="quiz-step"><p class="eyebrow" style="margin:0 0 10px">' + esc(A('result', 'Your routine')) + '</p>' +
        '<' + HT + ' tabindex="-1">' + (combo() && ans.prio === 'daynight' ? 'Your day & night routine.' : cats().length >= 3 ? 'Your all-in-one routine.' : 'Your personalized bundle.') + '</' + HT + '>' +
        '<p class="hint">' + esc(personalLine()) + ' Adjust bottles or add more below. ' + esc(A('note', '')) + '</p>' +
        mode +
        '<div class="qb-list">' + (rowsHtml || '<p class="qb-empty">Your bundle is empty — add a gummy below.</p>') + '</div>' +
        (extras.length ? '<div class="qb-more"><span>Add to your bundle</span><div>' + extras.map(function (p) { return '<button type="button" class="qb-add" data-qb-add="' + p.id + '" style="--accent:' + p.accent + '"><i style="background:' + p.bg + '"></i>' + esc(p.name) + ' <b>+</b></button>'; }).join('') + '</div></div>' : '') +
        '<div class="q-summary"><div><div class="qb-sum-l">' + c.bottles + (c.bottles === 1 ? ' bottle' : ' bottles') + (c.anySubLine ? ' · delivered monthly' : '') + (save > 0.005 ? ' · you save ' + money(save) : '') + '</div>' +
        '<strong>' + money(c.total) + (c.anySubLine ? ' / month' : ' total') + '</strong>' + (save > 0.005 ? ' <s class="qb-was">' + money(c.full) + '</s>' : '') + '</div>' +
        '<button type="button" class="btn btn-white" data-q-addall' + (c.bottles ? '' : ' disabled') + '>Add bundle to cart</button></div>' +
        '<p class="qb-fine">' + (c.anySubLine ? 'Subscription items renew monthly at the discounted price; skip or cancel anytime. ' : '') + (bundlePct ? 'Bundle discount on one-time bottles is applied at checkout.' : '') + '</p>' +
        '<div class="quiz-nav"><button type="button" class="btn btn-outline" data-q-restart>Start over</button><a class="link-arrow" href="' + R.all + '">Browse all gummies →</a></div></div>';
      if (focus) $(HT, body).focus();
    }
    function learn(focus) {
      bar.style.width = '100%';
      var picks = picksFor();
      body.innerHTML = '<div class="quiz-step"><p class="eyebrow" style="margin:0 0 10px">' + esc(A('result', 'Your routine')) + '</p>' +
        '<' + HT + ' tabindex="-1">Your gummy matches.</' + HT + '>' +
        '<p class="hint">' + esc(personalLine()) + ' Tap a gummy to see what’s inside, flavors and pricing. ' + esc(A('note', '')) + '</p>' +
        '<div class="ql-list">' + picks.map(function (p) {
          return '<a class="ql-card" href="' + p.url + '" data-q-go style="--accent:' + p.accent + ';--swatch:' + p.bg + '">' +
            '<span class="ql-media">' + (p.cards.length ? '<img src="' + p.cards[0] + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="ql-info"><span class="ql-goal">' + esc(p.goal) + '</span><strong>' + esc(fullName(p)) + '</strong>' + (p.line ? '<span class="ql-line">' + esc(p.line) + '</span>' : '') +
            '<span class="ql-cta">Learn more →</span></span></a>';
        }).join('') + '</div>' +
        '<div class="quiz-nav"><button type="button" class="btn btn-outline" data-q-restart>Start over</button><button type="button" class="btn btn-primary" data-q-tobundle>Build a bundle instead</button></div></div>';
      if (focus) $(HT, body).focus();
    }
    body.addEventListener('click', function (e) {
      if (e.target.closest('[data-q-go]')) { markSeen(); return; }
      if (step >= steps().length) {
        if (e.target.closest('[data-q-tobundle]')) { ans.path = 'bundle'; startBundle(); results(true); return; }
        if (e.target.closest('[data-q-restart]')) { ans = { goals: [], vibe: [], prio: null, path: null }; step = 0; draw(true); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
        var m = e.target.closest('[data-qmode]'); if (m) { bundle.sub = m.getAttribute('data-qmode') === 'sub'; results(false); return; }
        var st = e.target.closest('[data-qb]');
        if (st) { var id = st.getAttribute('data-qb'); bundle.qty[id] = Math.max(0, Math.min(12, (bundle.qty[id] || 0) + (+st.getAttribute('data-d')))); results(false); return; }
        var ad = e.target.closest('[data-qb-add]');
        if (ad) { var aid = ad.getAttribute('data-qb-add'); bundle.qty[aid] = 1; if (bundle.order.indexOf(aid) < 0) bundle.order.push(aid); results(false); return; }
        if (e.target.closest('[data-q-addall]')) {
          var items = lineCalc().rows.map(function (p) { return { id: p.id, pack: bundle.qty[p.id], sub: bundle.sub && hasSub(p) }; });
          if (items.length) addToCart(items);
        }
        return;
      }
      var s = steps()[step], o = e.target.closest('[data-v]');
      if (o) {
        var v = o.getAttribute('data-v');
        if (s.multi) { var i = ans[s.key].indexOf(v); if (i >= 0) ans[s.key].splice(i, 1); else ans[s.key].push(v); o.setAttribute('aria-pressed', String(i < 0)); }
        else { ans[s.key] = v; $$('[data-v]', body).forEach(function (b) { b.setAttribute('aria-pressed', String(b === o)); }); }
        $('[data-q-next]', body).disabled = !ok();
        return;
      }
      if (e.target.closest('[data-q-next]') && ok()) {
        if (step === 0) { ans.vibe = []; ans.prio = null; ans.path = null; }
        var ST = steps();
        if (step === ST.length - 1) { var only = picksFor(); if (only.length === 1) { markSeen(); window.location.href = only[0].url; return; } }
        step++; if (step >= ST.length && ans.path !== 'learn') startBundle(); draw(true); return;
      }
      if (e.target.closest('[data-q-back]')) { step--; draw(true); }
    });
    var params = new URLSearchParams(window.location.search);
    if (params.get('goal') && goals.indexOf(params.get('goal')) >= 0) ans.goals.push(params.get('goal'));
    draw(false);
  };

  function initFaq(root) {
    $$('[data-faq-more]', root).forEach(function (more) {
      var sec = more.closest('section'), faq = sec ? $('[data-faq]', sec) : null;
      if (!faq) return;
      if (!$('details.more', faq)) { more.hidden = true; return; }
      more.addEventListener('click', function () {
        var open = faq.classList.toggle('expanded');
        more.textContent = open ? 'Show less' : 'Show more';
        more.setAttribute('aria-expanded', String(open));
      });
    });
  }
  function paintTones(root) {
    $$('[data-tone]', root).forEach(function (el) { var p = byId(el.getAttribute('data-tone')); if (p) el.style.background = p.tone; });
    $$('[data-tone-dot]', root).forEach(function (el) { var p = byId(el.getAttribute('data-tone-dot')); el.style.background = p ? p.bg : 'var(--surface-2)'; });
  }
  function initWithin(root) {
    $$('[data-zapz]', root).concat(root.matches && root.matches('[data-zapz]') ? [root] : []).forEach(function (el) {
      var fn = INIT[el.getAttribute('data-zapz')];
      if (fn) { try { fn(el); } catch (e) { if (window.console) console.error('Zapz section error', e); } }
    });
    initFaq(root);
    paintTones(root);
  }

  /* ---------- header over first section ---------- */
  function headerState() {
    var h = $('.site-header'); if (!h) return;
    document.documentElement.style.setProperty('--head-h', h.offsetHeight + 'px');
    var first = firstVisibleSection();
    h.classList.toggle('on-light', !(first && $('.hero-slider', first)));
    h.classList.toggle('at-top', window.scrollY < 24);
  }
  var headTick = false;
  window.addEventListener('scroll', function () {
    if (headTick) return; headTick = true;
    requestAnimationFrame(function () { headTick = false; var h = $('.site-header'); if (h) h.classList.toggle('at-top', window.scrollY < 24); });
  }, { passive: true });
  window.addEventListener('resize', headerState);

  /* ---------- scroll reveal ---------- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var REVEAL = ('IntersectionObserver' in window) && !reduceMotion ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target; REVEAL.unobserve(el); el.classList.add('zr-in');
      setTimeout(function () { el.classList.remove('zr', 'zr-in'); el.style.removeProperty('--zr-d'); }, 1400);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  function revealTargets(sec) {
    var list = $$('.wrap > *', sec).filter(function (el) {
      return !/^(SCRIPT|STYLE|TEMPLATE)$/.test(el.tagName) && !el.closest('.slides, .sticky-buy, .hero-slider, .zr') && el.offsetParent !== null;
    });
    if (!list.length && sec.firstElementChild) list = [sec.firstElementChild];
    var out = [];
    list.forEach(function (el) {
      var kids = Array.prototype.slice.call(el.children), cs = getComputedStyle(el);
      var gridish = kids.length >= 3 && (cs.display.indexOf('grid') >= 0 || (cs.display.indexOf('flex') >= 0 && cs.flexWrap === 'wrap'));
      if (gridish) kids.forEach(function (k, i) { k.style.setProperty('--zr-d', (i % 6) * 80 + 'ms'); out.push(k); });
      else out.push(el);
    });
    return out;
  }
  function initReveal(root) {
    if (!REVEAL) return;
    var fv = firstVisibleSection();
    var secs = root === document ? $$('#main > .shopify-section').filter(function (x) { return x !== fv; }).concat($$('#shopify-section-zapz-footer')) : [root];
    secs.forEach(function (sec) {
      if ($('.hero-slider', sec)) return;
      revealTargets(sec).forEach(function (el) { el.classList.add('zr'); REVEAL.observe(el); });
    });
  }

  /* ---------- quiz test mode ---------- */
  function quizTestMode() {
    var q = null;
    try { q = new URLSearchParams(location.search).get('quiz'); if (q === 'test') sessionStorage.setItem('zapzQuizTest', '1'); if (q === 'off') sessionStorage.removeItem('zapzQuizTest'); } catch (e) {}
    var on = q === 'test'; try { on = on || sessionStorage.getItem('zapzQuizTest') === '1'; } catch (e) {}
    $$('[data-quiz-mode="test"]').forEach(function (w) {
      if (!on || (window.Shopify && window.Shopify.designMode)) return;
      w.classList.remove('quiz-hidden'); if (!w.hasAttribute('data-quiz-overlay')) w.classList.remove('quiz-out');
      var b = $('[data-quiz-test-badge]', w); if (b) b.hidden = false;
    });
  }
  var quizReturn = null;
  function closeQuiz() {
    var o = $('[data-quiz-overlay]'); if (!o || o.classList.contains('quiz-hidden')) return;
    try { sessionStorage.setItem('zapzQuizClosed', '1'); } catch (e) {}
    var done = function () { o.classList.add('quiz-hidden'); o.classList.remove('quiz-closing'); document.body.classList.remove('quiz-open'); var t = quizReturn && quizReturn !== document.body ? quizReturn : $('[data-open-menu]'); if (t && t.focus) t.focus(); };
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) done(); else { o.classList.add('quiz-closing'); setTimeout(done, 240); }
  }
  function initQuizOverlay() {
    var o = $('[data-quiz-overlay]'); if (!o) return;
    var closed = false; try { closed = sessionStorage.getItem('zapzQuizClosed') === '1' || localStorage.getItem('zapzQuizSeen') === '1'; } catch (e) {}
    try { if (new URLSearchParams(location.search).get('quiz') === 'test') closed = false; } catch (e) {}
    if (closed || o.classList.contains('quiz-hidden')) { o.classList.add('quiz-hidden'); return; }
    try { localStorage.setItem('zapzQuizSeen', '1'); } catch (e) {}
    var ph = document.createElement('div'); ph.className = 'quiz-out'; ph.hidden = true; o.parentNode.insertBefore(ph, o);
    document.body.appendChild(o);
    quizReturn = document.activeElement;
    document.body.classList.add('quiz-open');
    setTimeout(function () { var x = $('[data-quiz-close]', o); if (x) x.focus(); }, 50);
    o.addEventListener('click', function (e) { if (e.target.closest('[data-quiz-close]') || e.target.closest('[data-q-addall]') || e.target.closest('[data-q-add]')) closeQuiz(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && document.body.classList.contains('quiz-open')) closeQuiz(); });
  }
  function firstVisibleSection() { return $$('#main > .shopify-section').filter(function (x) { return !$('.quiz-hidden', x) || !x.querySelector(':scope > .quiz-out'); })[0]; }

  /* ---------- boot ---------- */
  function boot() {
    quizTestMode();
    initQuizOverlay();
    bindHeader(document);
    bindGlobal();
    initWithin(document);
    headerState();
    initReveal(document);
    renderCart();
    refreshCart().catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Theme editor: re-initialise only the section that changed — no page reloads.
  document.addEventListener('shopify:section:unload', function (e) { var f = CLEANUP[e.target.id]; if (f) f(); });
  document.addEventListener('shopify:section:load', function (e) {
    if ($('.announce, .pill', e.target)) bindHeader(e.target);
    initWithin(e.target);
    headerState();
    if (e.target.closest && e.target.closest('#main')) initReveal(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var host = $('[data-zapz]', e.target) || e.target;
    $$('[data-zapz]', e.target).forEach(function (el) { if (el._select) el._select(e.detail.blockId); });
    if (host._select) host._select(e.detail.blockId);
  });
})();
